'use client'

import { Question } from '@entities/lesson'
import {
  createFunnelStepKey,
  createNextFunnelStepKey,
  getMasterAnswerByQuestion,
  isLastStep,
  lessonReviewAnswerStatusSchema,
  lessonReviewFunnelStepSchema,
  QuestionFunnelStepContextMap,
} from '@features/lesson-review'
import { useFunnel, UseFunnelOptions } from '@use-funnel/browser'

export const useLessonReviewQuestionFunnel = (questions: Question[]) => {
  const INITIAL_FUNNEL_KEY = createFunnelStepKey(0)
  const INITIAL_FUNNEL_ANSWER = {
    user_answer: '',
    master_answer: getMasterAnswerByQuestion(questions[0]),
    question_type: questions[0].type,
    status: lessonReviewAnswerStatusSchema.Enum.NOT_ANSWERED,
  }

  const lessonsReviewFunnel = useFunnel<QuestionFunnelStepContextMap>({
    id: 'lesson-review',
    // 동적으로 스텝 생성 - 문제 개수에 따라 퍼널의 수가 변경됨
    steps: questions.reduce(
      (acc, _, idx) => ({
        ...acc,
        [createFunnelStepKey(idx)]: { parse: lessonReviewFunnelStepSchema.parse },
      }),
      {},
    ),
    initial: {
      step: INITIAL_FUNNEL_KEY,
      context: {
        questions: questions,
        answers: {
          [INITIAL_FUNNEL_KEY]: INITIAL_FUNNEL_ANSWER,
        },
      },
    },
  } satisfies UseFunnelOptions<QuestionFunnelStepContextMap>)

  const currentFunnelStepKey = createFunnelStepKey(lessonsReviewFunnel.index)
  const nextFunnelStepKey = createNextFunnelStepKey(lessonsReviewFunnel.index)
  const isLastFunnelStep = isLastStep(lessonsReviewFunnel.index, questions.length)
  const currentFunnel = lessonsReviewFunnel.context.answers[currentFunnelStepKey]

  return {
    lessonsReviewFunnel,
    options: { currentFunnelStepKey, nextFunnelStepKey, isLastFunnelStep, currentFunnel },
  }
}
